__turbopack_context__.v({
  "form-head": "form-head-module-scss-module__ukwP0q__form-head",
  "has-bg": "form-head-module-scss-module__ukwP0q__has-bg",
  "placeholder": "form-head-module-scss-module__ukwP0q__placeholder",
});
